import qs from "qs";
import request from "@/utils/requestSC";
import requestApi from "@/utils/requestApi";

export default {
  name: "orderThirdparty",

  data() {
    return {
      size: 5,
      date: [],
      list: [],
      total: 0,
      current: 1,
      loading: false,
      searchForm: {
        orderId: "",
        goodsName: "",
        syncStatus: "",
        orderStatus: "",
        orderTimeEnd: "",
        orderTimeStart: "",
      },
      statusList: [],
      syncStatusList: [],
    };
  },
  watch: {
    date(val) {
      if (val) {
        this.searchForm.orderTimeEnd = val[1];
        this.searchForm.orderTimeStart = val[0];
      } else {
        this.searchForm.orderTimeEnd = "";
        this.searchForm.orderTimeStart = "";
      }
    },
  },
  created() {
    requestApi
      .post("scbasic/dataDictionary/selDataDictionaryItemList", {
        dictId: "ORDER_STATUS_TYPE",
      })
      .then((res) => {
        this.statusList = res.data;
      });
    requestApi
      .post("scbasic/dataDictionary/selDataDictionaryItemList", {
        dictId: "THIRD_PARTY_ORDER_SYNC_STATUS",
      })
      .then((res) => {
        this.syncStatusList = res.data;
      });
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      const {
        data: { count, results },
      } = await request.post(`order/thirdPartyOrder/sync/selPage`, {
        ...this.searchForm,
        size: this.size,
        current: this.current,
      });
      this.list = results;
      this.total = count;
      this.loading = false;
    },
    searchReset() {
      this.date = null;
      this.$refs.searchForm.resetFields();
    },
    async manualSync(item) {
      this.loading = true;
      const { data } = await request.post(
        `order/thirdPartyOrder/sync/manualSyncOrder`,
        qs.stringify({
          type: item.syncType,
          orderId: item.orderId,
        })
      );
      this.loading = false;
      console.log("manualSync-data", data);
      this.getList();
    },
    currentChange(val) {
      this.current = val;
      this.getList();
    },
    searchSubmit() {
      this.current = 1;
      this.getList();
    },
  },
};
